import { HttpContextToken } from '@angular/common/http';

export const SILENCE_ERROR = new HttpContextToken<boolean>(() => false);